import { render, staticRenderFns } from "./AssetsView.vue?vue&type=template&id=e9bc7af0"
import script from "./AssetsView.vue?vue&type=script&lang=ts"
export * from "./AssetsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports